import { Delete16 } from 'ui/icons/aurora/16px/Delete16';
import { BulkActionsBar as BulkActionsBarUi } from 'ui/bulkActionsBar';
import { useSelectionContext } from '../../contexts/SelectionContext';
import {
  useOrganizationModalsContext,
  MODAL_NAMES,
} from '../../contexts/OrganizationModalsContext';
import { useOrganizationMembersQueryContext } from '../../contexts/OrganizationMembersQueryContext';

export const BulkActionsBar = () => {
  const { selected } = useSelectionContext();
  const { membersById } = useOrganizationMembersQueryContext();
  const { showModal } = useOrganizationModalsContext();

  if (!selected.length) return null;

  return (
    <BulkActionsBarUi
      actions={[
        {
          active: true,
          label: 'Revoke access',
          icon: <Delete16 />,
          onClick: () => {
            const members = selected.map((id) => membersById[id]).filter(Boolean);
            if (members.length === 1) {
              showModal({
                name: MODAL_NAMES.REVOKE_ACCESS,
                payload: { member: members[0] },
              });
            } else if (members.length > 1) {
              showModal({
                name: MODAL_NAMES.BULK_REVOKE_ACCESS,
                payload: { members },
              });
            }
          },
          sortIndex: 0,
        },
      ]}
      numSelected={selected.length}
    />
  );
};
